"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const PinnedIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.46 1.146c-.365-.364-.991-.09-.977.427l.115 1.433-4.737 3.397-2.273.137c-.489.036-.714.63-.37.975l2.53 2.53-2.686 2.686a.58.58 0 00-.117.168l-.66 1.437c-.11.24.136.486.376.376l1.437-.66a.58.58 0 00.168-.116l2.686-2.687 2.533 2.533c.344.344.938.12.975-.369l.14-2.283 3.393-4.733 1.427.114c.518.015.793-.612.429-.976l-4.39-4.39z"
  })))
});
PinnedIcon.displayName = 'PinnedIcon';
var _default = exports.default = PinnedIcon;